import { DatadogErrorLevels } from '@bts-web/utils-next-infrastructure';
import { datadogErrorHelper } from '../../../../common/utils/datadogErrorHelper';

const OPEN_BANKING_INFO_SCREEN_DISMISSED_KEY = 'openBankingInfoScreenDismissed';

const DISMISSED_VALUE = 'true';

export const hasDismissedOpenBankingInfoScreen = (): boolean => {
  try {
    return (
      localStorage.getItem(OPEN_BANKING_INFO_SCREEN_DISMISSED_KEY) ===
      DISMISSED_VALUE
    );
  } catch {
    datadogErrorHelper({
      errorMessage: 'Failed to read open banking info screen dismissal status',
      errorSeverity: DatadogErrorLevels.WARNING,
    });

    return false;
  }
};

export const dismissOpenBankingInfoScreen = (): void => {
  try {
    localStorage.setItem(
      OPEN_BANKING_INFO_SCREEN_DISMISSED_KEY,
      DISMISSED_VALUE,
    );
  } catch {
    datadogErrorHelper({
      errorMessage: 'Failed to persist open banking info screen dismissal',
      errorSeverity: DatadogErrorLevels.WARNING,
    });
  }
};
